module.exports = __webpack_public_path__ + "HelveticaLight.0c4dbb71b018b0313e21.eot";


//////////////////
// WEBPACK FOOTER
// /var/www/minha-jnnet/src/app/@theme/fontes/Helvetica/HelveticaLight.eot
// module id = ../../../../../src/app/@theme/fontes/Helvetica/HelveticaLight.eot
// module chunks = styles